import { useMutation } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";

import { uploadProfilePhoto } from "../../services/portalAluno/profile/profileService";
import { updateAuthPhoto } from "../../store/ducks/auth/actions";
import type { ApplicationState } from "../../store";

const useProfilePhoto = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state: ApplicationState) => state.auth.data);

  return useMutation({
    mutationFn: (file: File) => {
      if (!auth?.idUsuario) throw new Error("Sessão de usuário inválida.");
      return uploadProfilePhoto(file);
    },
    onSuccess: (imgUsuario) => dispatch(updateAuthPhoto(imgUsuario)),
  });
};

export default useProfilePhoto;
